import classes from "../classes";
import { FormattedBuyIn } from "./formatted-currency";
import { getSmallBadges } from "../badges";
import { Link, withRouter } from "react-router-dom";
import pure from "./higher-order/pure";
import React from "react";
import scoring from "../scoring";
import TournamentCountdown from "./tournament-countdown";
import TournamentPrize from "./tournament-prize";
import TournamentStatus from "./tournament-status";
import { trackListShort } from "../track-list";
import { trackTournamentClick } from "../analytics";

export default withRouter(pure(function TournamentListItemHeader({ isGameBoard, myTicketsForTournament, position, races, toggle, tokenTypes, tournament }) {
  var tracks = trackListShort(races);
  var trackElements = Object.keys(tracks).map((track) => track + " " + tracks[track]);

  var tbd = trackElements.length === 0;
  if (tbd) {
    trackElements = ["TBD"];
  }

  var descriptionElement;
  if (tournament.get("description")) {
    descriptionElement = (
      <p className="tournament-table_sub">
        {tournament.get("description")}
      </p>
    );
  }

  var tournamentUrl = "/tournaments/" + tournament.get("id");
  return (
    <div className="tournament-table_row tournament-table_row--game batch-g batch-g--padding batch-g--valign-center">
      <div className="batch-c-3-4 batch-c-md-1-2 batch-c-order-md-1">
        <Link className="tournament-table_link" onClick={() => trackTournamentClick(tournament, position)} to={tournamentUrl}>
          {tournament.get("name")}
        </Link>

        {descriptionElement}

        <ul className="tournament-table_inline-list">
          <li>
            {getSmallBadges(tournament, true)}
          </li>

          <li>
            {scoring(tournament)}
          </li>

          <li>
            {trackElements.map(trackInfo => (
              <span key={trackInfo}>
                {trackInfo}
              </span>
            ))}
          </li>

          <li>
            <button className="btn btn--clean btn--tiny btn--short btn--no-focus color--is-medium-gray tooltip" data-tooltip="Preview this game." onClick={toggle} type="button">
              <span className="display--is-none">
                Preview
              </span>

              <i className="dw-dots-three-horizontal dw--1-5x" />
            </button>
          </li>
        </ul>
      </div>

      <div className="batch-c-1-4 batch-c-md-1-12 batch-c-order-md-9 tournament-table_cell--cta">
        <TournamentStatus isGameBoard={isGameBoard} myTickets={myTicketsForTournament} tournament={tournament} />
      </div>

      <div className="batch-c-1-4 batch-c-md-1-10 batch-c-order-md-5">
        <span aria-label="Prize" className="tournament-table_label tournament-table_label--prize tournament-table_mobile-label">
          <TournamentPrize tokenTypes={tokenTypes} tournament={tournament} />
        </span>
      </div>

      <div className="batch-c-1-4 batch-c-md-1-10 batch-c-order-md-6">
        <span aria-label="Entry" className="tournament-table_label tournament-table_mobile-label">
          <FormattedBuyIn tokenTypes={tokenTypes} tournament={tournament} />
        </span>
      </div>

      <div className="batch-c-1-4 batch-c-md-1-12 batch-c-order-md-7">
        <span aria-label="Players" className="tournament-table_label tournament-table_mobile-label">
          <PlayerCount isGameBoard={isGameBoard} tournament={tournament} />
        </span>
      </div>

      <div className="batch-c-1-4 batch-c-md-1-8 batch-c-order-md-8">
        <span aria-label="Closes" className="tournament-table_label tournament-table_mobile-label">
          <TournamentCountdown racesForTournament={races} tournament={tournament} />
        </span>
      </div>
    </div>
  );
}));

var PlayerCount = pure(function PlayerCount({ isGameBoard, tournament }) {
  var tooltip;
  var players = tournament.get("max_users") - tournament.get("remaining_entries");
  var needed = tournament.get("number_of_users_required") - players;
  var color;
  if (isGameBoard) {
    if (needed > 0) {
      tooltip = "This game needs " + needed + " more " + (needed === 1 ? "entry" : "entries") + " to meet the minimum.";
      color = "color--is-error";
      if (tournament.get("alternate_active") && players >= tournament.get("alternate_number_of_users_required")) {
        color = "color--is-caution";
      }
    } else {
      color = "color--is-success ";
    }
  }
  return (
    <span
      className={classes({
        "tooltip": tooltip,
        [color]: color
      })}
      data-tooltip={tooltip}>
      {tournament.get("max_users") - tournament.get("remaining_entries")}
    </span>
  );
});
